import { render, staticRenderFns } from "./asset_alert_icon.vue?vue&type=template&id=11b2a7c1&scoped=true&"
import script from "./asset_alert_icon.vue?vue&type=script&lang=js&"
export * from "./asset_alert_icon.vue?vue&type=script&lang=js&"
import style0 from "./asset_alert_icon.vue?vue&type=style&index=0&id=11b2a7c1&prod&scss=true&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b2a7c1",
  null
  
)

export default component.exports